<template>
  <div class="shipments-filters">
    <ais-numeric-menu
      attribute="departureUTC"
      :items="[
        {label: 'from_today_onwards', start: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).unix()}
      ]"
    >
      <template
        slot-scope="{ items, refine }"
      >
        <v-chip
          v-for="item in items"
          :key="item.label"
          ref="items"
          class="ma-2"
          @click="handleDepartureFromToday(item.value, refine)"
          @click:close="handleDepartureFromToday(item.value, refine, false)"
          :close="isDepartureFromTodayApplied"
        >
        {{ $t(`shipments.${item.label}`) }}
        </v-chip>
      </template>
    </ais-numeric-menu>
    <AlgoliaCurrentFilters
      @clear-all="handleClearAll"
    />
    <AlgoliaDateFilter
      v-for="(dateFilter, index) in dateFilters"
      :key="index"
      :index="index"
      :dateFilter="dateFilter"
    />
    <AlgoliaSelectableFilters :arrFilters="arrFilters" />
    <AlgoliaNumericFilters :numFilters="numericFilters" />
  </div>
</template>

<script>
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaDateFilter from '@/components/general/AlgoliaDateFilter2'
import AlgoliaNumericFilters from '@/components/general/AlgoliaNumericFilters'
import AlgoliaCurrentFilters from '@/components/general/AlgoliaCurrentFilters'
import moment from 'moment-timezone'

export default {
  name: 'ShipmentFilter',
  components: {
    AlgoliaSelectableFilters,
    AlgoliaDateFilter,
    AlgoliaNumericFilters,
    AlgoliaCurrentFilters
  },
  props: {},
  data () {
    return {
      isDepartureFromTodayApplied: false,
      moment,
      clearRefine: null,
      typeColorMap: {
        '1PL': '#50E898',
        '2PL': '#2196F3',
        '3PL': '#9C27B0',
        'Express': '#ef476f'
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.items != null) {
        if (this.$refs.items[0] != null) {
          this.$refs.items[0].click()
        }
      }
    }, 240)
  },
  methods: {
    handleDepartureFromToday(value, refine, flag = true) {
      if (flag) {
        refine(value)
        this.isDepartureFromTodayApplied = !this.isDepartureFromTodayApplied
      } else {
        refine(value)
        this.isDepartureFromTodayApplied = false
      }
    },
    handleClearAll () {
      this.isDepartureFromTodayApplied = false
    }
  },
  computed: {
    arrFilters () {
      return [
        // { title: this.$i18n.t('shipments.type'), attribute: 'type', colorMap: this.typeColorMap },
        // { title: this.$i18n.t('orders.status'), attribute: 'status', i18nPreffix: 'orders.' },
        { title: this.$i18n.t('shipments.labels'), attribute: 'labels' },
        { title: this.$i18n.t('shipments.status'), attribute: 'status', i18nPreffix: 'shipments.' }
        // { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller'), attribute: 'origin.company' },
        // { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'destination.company' },
        // { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin'), attribute: 'origin.address' },
        // { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination'), attribute: 'destination.address' },
        // { title: this.$i18n.t('shipments.vehicle_owner'), attribute: 'carrier.name' },
        // { title: this.$i18n.t('shipments.driver'), attribute: 'vehicle.driver' }
      ]
    },
    numericFilters () {
      return [
        { title: this.$i18n.t('shipments.volume'), attribute: 'volume'},
        { title: this.$i18n.t('shipments.weight'), attribute: 'weight'}
      ]
    },
    dateFilters () {
      return [
        { title: this.$i18n.t('shipments.departure'), attribute: 'pickupLocal.from' },
        { title: this.$i18n.t('shipments.arrival'), attribute: 'deliveryLocal.from' }
      ]
    }
  },
}
</script>
